<template>
  <div class="row mx-0 px-3 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="">電話番号</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
      <div class="row p-0">
        <div class="col-12 col-md-4 pe-0 mb-3">
          <Field v-slot="{ field, errors }" v-model="additionalStore.tel" name="tel">
            <input
              type="tel"
              class="input-primary form-control size-14 bg-silver-primary p-0d8 border-0"
              placeholder="例）08012345678"
              v-bind="field"
              :class="{ 'is-invalid': !!errors.length }"
              pattern="[0-9]*"
              inputmode="numeric"
              @keydown="handleKeyDown"
              @input="handleInput"
              @compositionend="handleComposition"
            />
            <ErrorMessage name="tel" class="invalid-feedback" />
          </Field>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAdditionalStore } from '@/stores/resume-candidate/Additional.store';
import { Field, ErrorMessage } from 'vee-validate';

const additionalStore = useAdditionalStore();

const handleKeyDown = (e: KeyboardEvent): void => {
  const allowedKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
  if ((e.ctrlKey || e.metaKey) && ['c', 'v', 'x', 'a'].includes(e.key)) {
    return;
  }
  if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
    e.preventDefault();
  }
  if (!allowedKeys.includes(e.key) && !/^\d$/.test(e.key)) {
    e.preventDefault();
  }
};

const handleInput = (e: Event): void => {
  const input = e.target as HTMLInputElement;
  const cleaned = input.value.replace(/[^\d-]/g, '');
  if (input.value !== cleaned) {
    input.value = cleaned;
    additionalStore.tel = cleaned;
  }
};

const handleComposition = (e: CompositionEvent): void => {
  const input = e.target as HTMLInputElement;
  input.value = input.value.replace(/[^\d-]/g, '');
  additionalStore.tel = input.value;
};
</script>
